<template>
  <div class="contents">
    <div class="container-fluid">
      <div class="breadcrumb-main user-member justify-content-sm-between mb-3">
        <h4 class="text-capitalize fw-500 breadcrumb-title">
          <a @click="goBack" style="cursor:pointer"><i class="fas fa-arrow-left"></i></a>
          &nbsp; Donasi — {{ shopName }}
        </h4>
        <div>
          <a :href="'/toko/' + shopSlug + '/donasi'" target="_blank" class="btn btn-light btn-sm mr-2">
            <i class="fas fa-external-link-alt"></i> Halaman Donasi
          </a>
          <button class="btn btn-light btn-sm" @click="load" :disabled="isLoading">
            <i class="fas fa-sync"></i> Refresh
          </button>
        </div>
      </div>

      <!-- Stats -->
      <div class="row mb-3" v-if="stats">
        <div class="col-md-3">
          <div class="card p-3 border bg-white radius-xl">
            <small class="text-muted">Total Donasi</small>
            <h3 class="mb-0 text-primary">{{ formatRupiah(stats.total_amount) }}</h3>
            <small>{{ stats.total_count }} transaksi</small>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card p-3 border bg-white radius-xl">
            <small class="text-muted">Donasi Hari Ini</small>
            <h3 class="mb-0 text-success">{{ formatRupiah(stats.today_amount) }}</h3>
            <small>{{ stats.today_count }} transaksi</small>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="card p-3 mb-3 border bg-white radius-xl">
        <div class="row">
          <div class="col-md-3">
            <label>Status Pembayaran</label>
            <select v-model="filterStatus" class="form-control" @change="load">
              <option value="">Semua</option>
              <option value="pending">Pending</option>
              <option value="paid">Paid</option>
              <option value="expired">Expired</option>
            </select>
          </div>
          <div class="col-md-3">
            <label>Dari Tanggal</label>
            <input v-model="filterDateFrom" type="date" class="form-control" @change="load">
          </div>
          <div class="col-md-3">
            <label>Sampai Tanggal</label>
            <input v-model="filterDateTo" type="date" class="form-control" @change="load">
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="card p-4 border bg-white radius-xl">
        <div v-if="isLoading" class="text-center p-4"><div class="spinner-border"></div></div>
        <div v-else-if="donations.length === 0" class="text-muted text-center p-4">Belum ada donasi.</div>
        <table v-else class="table table-sm">
          <thead>
            <tr>
              <th>Tanggal</th>
              <th>Donatur</th>
              <th>Nominal</th>
              <th>Metode</th>
              <th>Status</th>
              <th>Pesan</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="d in donations" :key="d.id">
              <td><small>{{ formatDate(d.created_at) }}</small></td>
              <td>
                {{ displayDonor(d) }}<br>
                <small class="text-muted">{{ d.donor_phone }}</small>
              </td>
              <td><b>{{ formatRupiah(d.amount) }}</b></td>
              <td><small>{{ d.payment_method || '-' }}</small></td>
              <td><span class="badge" :class="statusBadge(d.payment_status)">{{ d.payment_status }}</span></td>
              <td><small>{{ d.message || '-' }}</small></td>
              <td>
                <button v-if="d.payment_status === 'pending'" class="btn btn-sm btn-success" @click="markPaid(d)">
                  ✓ Tandai Dibayar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shopId: null,
      shopName: '',
      shopSlug: '',
      isLoading: false,
      donations: [],
      stats: null,
      filterStatus: '',
      filterDateFrom: '',
      filterDateTo: '',
    };
  },
  mounted() {
    this.shopId = this.$route.params.id;
    this.load();
    this.loadShop();
  },
  methods: {
    goBack() {
      this.$router.push('/shop/' + this.shopId + '?tab=produk');
    },
    async loadShop() {
      try {
        const r = await this.$store.dispatch('shop/shop_detail', this.shopId);
        this.shopName = r.data.data.shop.name;
        this.shopSlug = r.data.data.shop.slug;
      } catch (e) { /* noop */ }
    },
    async load() {
      this.isLoading = true;
      try {
        const params = {};
        if (this.filterStatus) params.payment_status = this.filterStatus;
        if (this.filterDateFrom) params.date_from = new Date(this.filterDateFrom).getTime();
        if (this.filterDateTo) {
          const d = new Date(this.filterDateTo);
          d.setHours(23, 59, 59, 999);
          params.date_to = d.getTime();
        }
        const [listR, statsR] = await Promise.all([
          this.$store.dispatch('shop_donation/donation_list', { shopId: this.shopId, params }),
          this.$store.dispatch('shop_donation/donation_stats', this.shopId),
        ]);
        this.donations = listR.data.data.donations || [];
        this.stats = statsR.data.data;
      } catch (e) {
        this.$toast.error(e.response?.data?.message || 'Gagal load donasi');
      }
      this.isLoading = false;
    },
    async markPaid(d) {
      if (!confirm('Tandai donasi ini sudah dibayar?')) return;
      try {
        await this.$store.dispatch('shop_donation/donation_mark_paid', d.id);
        this.$toast.success('Donasi ditandai dibayar');
        this.load();
      } catch (e) {
        this.$toast.error(e.response?.data?.message || 'Gagal');
      }
    },
    displayDonor(d) {
      if (d.is_anonymous) return 'Anonim';
      return d.donor_name || 'Donatur';
    },
    formatRupiah(v) { return 'Rp ' + (v || 0).toLocaleString('id-ID'); },
    formatDate(ms) {
      if (!ms) return '-';
      return new Date(ms).toLocaleString('id-ID');
    },
    statusBadge(s) {
      return { pending: 'badge-warning', paid: 'badge-success', expired: 'badge-secondary', failed: 'badge-danger' }[s] || 'badge-light';
    },
  },
};
</script>
